import { NotificationCustomProps } from '@/utils/hooks/context/toast/types';

// Components
import Notification from '@/components/base/Notification';

const DefaultCustomNotification = ({ notification }: NotificationCustomProps) => {
    return (
        <Notification
            dataNotification={notification}
            type={notification?.options?.variant}
            contentHidden={notification?.options?.hideContent ?? false}
            wide={notification?.options?.wide ?? true}>
            {notification.data?.icon ? <Notification.Icon icon={notification.data.icon} /> : null}
            <Notification.Content>
                {notification.data?.title ? (
                    <Notification.Title>{notification.data.title}</Notification.Title>
                ) : null}
                {notification.data?.description ? (
                    <Notification.Description>
                        {notification.data.description}
                    </Notification.Description>
                ) : null}
            </Notification.Content>
            {notification?.data?.action ? notification?.data?.action : null}
            {notification?.options?.cancelAction &&
            typeof notification.options.cancelAction === 'function' ? (
                <Notification.CancelButton
                    onClick={() => {
                        notification.options.cancelAction();

                        // Hide toast
                        if (
                            notification?.options?.hideToast &&
                            typeof notification.options.hideToast === 'function'
                        ) {
                            notification.options.hideToast();
                        }
                    }}
                />
            ) : null}
            {notification?.options?.progressBar.show ? (
                <Notification.ProgressBar
                    duration={notification?.options?.progressBar?.duration}
                    pause={notification?.options?.progressBar?.pause}
                    onAnimationEnd={notification?.options?.progressBar?.onAnimationEnd}
                />
            ) : null}
        </Notification>
    );
};

export default DefaultCustomNotification;
